// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Env from "../../core/Env.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as Form from "../../bundles/Form/Form.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Json from "../../primitives/Json.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as Title from "../../resources/typography/Title.res.js";
import * as React from "react";
import * as Banner from "../../resources/feedback-indicators/Banner.res.js";
import * as Button from "../../resources/actions/Button.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as FuturePromise from "rescript-future/src/FuturePromise.res.js";
import * as LegacyDashboard from "../../modules/LegacyDashboard.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
function get(values, field) {
  switch (field) {
    case "Username":
      return values.username;
    case "Password":
      return values.password;
    case "KeepSigned":
      return values.keepSigned;
  }
}
function set(values, field, value) {
  switch (field) {
    case "Username":
      return {
        username: value,
        password: values.password,
        keepSigned: values.keepSigned
      };
    case "Password":
      return {
        username: values.username,
        password: value,
        keepSigned: values.keepSigned
      };
    case "KeepSigned":
      return {
        username: values.username,
        password: values.password,
        keepSigned: value
      };
  }
}
let LoginFormLenses_ = {
  get: get,
  set: set
};
let LoginFormLenses = {
  get: get,
  set: set
};
let LoginForm = Form.Make(LoginFormLenses);
function encodeBody(username, password) {
  return Json.stringify(Json.encodeDict(Object.fromEntries([["username", Json.encodeString(username)], ["password", Json.encodeString(password)]])));
}
function decodeResult(json) {
  return Json.flatDecodeDictFieldString(Json.decodeDict(json), "access_token");
}
function make(username, password) {
  return Future.map(FuturePromise.fromPromise(fetch(Env.gatewayUrl() + "/sign-in", {
    method: "POST",
    body: Primitive_option.some(encodeBody(username, password)),
    headers: Primitive_option.some(new Headers({
      "Content-Type": "application/json"
    }))
  }).then(prim => prim.json()).then(json => Promise.resolve(Json.flatDecodeDictFieldString(Json.decodeDict(json), "access_token")))), undefined, result => {
    if (result.TAG !== "Ok") {
      return {
        TAG: "Error",
        _0: undefined
      };
    }
    let jwt = result._0;
    if (jwt !== undefined) {
      return {
        TAG: "Ok",
        _0: jwt
      };
    } else {
      return {
        TAG: "Error",
        _0: undefined
      };
    }
  });
}
let SignInRequest = {
  encodeBody: encodeBody,
  decodeResult: decodeResult,
  make: make
};
let styles = {
  root: {
    "color-kMwMTN": "color-x1wohto9",
    "font-kVVagm": "font-xhhohpu",
    "textDecorationLine-kMnn75": "textDecorationLine-xujl8zx",
    $$css: "wino-gc:src/app/Auth/AuthLoginPage.res.js:121"
  }
};
function styleProps() {
  return {
    className: "color-x1wohto9 font-xhhohpu textDecorationLine-xujl8zx",
    "data-style-src": "wino-gc:src/app/Auth/AuthLoginPage.res.js:121"
  };
}
function AuthLoginPage$RecoveryLinkButton(props) {
  let match = {
    className: "color-x1wohto9 font-xhhohpu textDecorationLine-xujl8zx",
    "data-style-src": "wino-gc:src/app/Auth/AuthLoginPage.res.js:121"
  };
  return JsxRuntime.jsx(Navigation.Link.make, {
    children: JsxRuntime.jsx("span", {
      children: I18n.t("Forgot password ?"),
      className: match.className,
      style: match.style
    }),
    to: {
      TAG: "Route",
      _0: props.recoveryRoute
    }
  });
}
let RecoveryLinkButton = {
  styles: styles,
  styleProps: styleProps,
  make: AuthLoginPage$RecoveryLinkButton
};
function AuthLoginPage$NotificationBanner(props) {
  return JsxRuntime.jsx(Box.make, {
    children: JsxRuntime.jsx(Banner.make, {
      textStatus: props.notification,
      onRequestClose: props.onRequestClose
    }),
    spaceTop: "medium",
    style: {
      width: "100%"
    }
  });
}
let make$1 = React.memo(AuthLoginPage$NotificationBanner);
let NotificationBanner = {
  make: make$1
};
let styles$1 = {
  container: {
    "alignItems-kGNEyG": "alignItems-x1qjc9v5",
    "display-k1xSpc": "display-x78zum5",
    "flex-kUk6DE": "flex-x98rzlu",
    "flexDirection-kXwgrk": "flexDirection-xdt5ytf",
    "justifyContent-kjj79g": "justifyContent-xl56j7k",
    "marginTop-keoZOQ": "marginTop-xugmn4g",
    "width-kzqmXN": "width-x2cbyk5",
    $$css: "wino-gc:src/app/Auth/AuthLoginPage.res.js:173"
  },
  title: {
    "alignItems-kGNEyG": "alignItems-x6s0dn4",
    "display-k1xSpc": "display-x78zum5",
    "flexDirection-kXwgrk": "flexDirection-xdt5ytf",
    "paddingBlock-k8WAf4": "paddingBlock-xqp6ajr",
    "width-kzqmXN": "width-xh8yej3",
    $$css: "wino-gc:src/app/Auth/AuthLoginPage.res.js:182"
  }
};
function noop(param) {}
let schema = [{
  TAG: "Email",
  _0: "Username"
}, {
  TAG: "StringMin",
  _0: "Password",
  _1: 3
}];
function AuthLoginPage(props) {
  let __initialUsername = props.initialUsername;
  let initialNotification = props.initialNotification;
  let signInRequest = props.signInRequest;
  let initialUsername = __initialUsername !== undefined ? __initialUsername : "";
  let authState = Auth.useState();
  let logUser = Auth.useLogUser(undefined, undefined);
  let match = React.useState(() => initialNotification);
  let setNotfication = match[1];
  let notification = match[0];
  let onSubmitSuccess = jwt => {
    if (jwt !== undefined) {
      return logUser(jwt);
    } else {
      return setNotfication(param => ({
        TAG: "Danger",
        _0: I18n.t("Something went wrong")
      }));
    }
  };
  let onSubmitFailure = error => setNotfication(param => ({
    TAG: "Danger",
    _0: error
  }));
  let formPropState = LoginForm.useFormPropState({
    initialValues: {
      username: initialUsername,
      password: "",
      keepSigned: true
    },
    schema: schema,
    onSubmitFailure: onSubmitFailure,
    onSubmitSuccess: onSubmitSuccess
  });
  let onSubmit = (param, param$1) => Future.mapError(Future.mapOk(signInRequest(param$1.username, param$1.password), undefined, jwt => jwt), undefined, () => I18n.t("Incorrect credentials."));
  let onRequestCloseNotificationBanner = () => setNotfication(param => {});
  let newrecord = {
    ...{
      className: "alignItems-x1qjc9v5 display-x78zum5 flex-x98rzlu flexDirection-xdt5ytf justifyContent-xl56j7k marginTop-xugmn4g width-x2cbyk5",
      "data-style-src": "wino-gc:src/app/Auth/AuthLoginPage.res.js:173"
    }
  };
  let newrecord$1 = {
    ...{
      className: "alignItems-x6s0dn4 display-x78zum5 flexDirection-xdt5ytf paddingBlock-xqp6ajr width-xh8yej3",
      "data-style-src": "wino-gc:src/app/Auth/AuthLoginPage.res.js:182"
    }
  };
  let tmp;
  let exit = 0;
  if (typeof authState !== "object") {
    tmp = JsxRuntime.jsx(LoginForm.SubmitButton.make, {
      label: I18n.t("Sign in"),
      size: "large",
      onSubmit: onSubmit
    });
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = JsxRuntime.jsx(Button.make, {
      label: I18n.t("Sign in"),
      variant: "solid",
      tone: "brand",
      size: "large",
      pending: true
    });
  }
  newrecord.children = [JsxRuntime.jsxs("div", (newrecord$1.children = [JsxRuntime.jsx(Title.make, {
    children: I18n.t("Good to see you again !"),
    level: 1
  }), notification !== undefined ? JsxRuntime.jsx(make$1, {
    notification: notification,
    onRequestClose: onRequestCloseNotificationBanner
  }) : null, JsxRuntime.jsx(LegacyDashboard.Banner.make, {
    spaceTop: "medium"
  })], newrecord$1)), JsxRuntime.jsxs(LoginForm.Core.Provider.make, {
    children: [JsxRuntime.jsx(LoginForm.ControlEnterKey.make, {
      onSubmit: onSubmit
    }), JsxRuntime.jsxs(Stack.make, {
      children: [JsxRuntime.jsx(LoginForm.InputText.make, {
        field: "Username",
        label: I18n.t("Email address"),
        placeholder: I18n.t("name@yourcompany.com"),
        hideRequired: true,
        copyable: true
      }), JsxRuntime.jsx(LoginForm.InputPassword.make, {
        field: "Password",
        label: I18n.t("Password"),
        placeholder: I18n.t("Password"),
        hideError: true,
        hideRequired: true
      }), JsxRuntime.jsx(Box.make, {
        children: tmp,
        spaceY: "xsmall"
      })],
      space: "large"
    }), JsxRuntime.jsx(AuthLoginPage$RecoveryLinkButton, {
      recoveryRoute: props.recoveryRoute
    })],
    propState: formPropState
  })];
  return JsxRuntime.jsxs("div", newrecord);
}
let signInRequest = make;
let make$2 = AuthLoginPage;
export { LoginFormLenses_, LoginFormLenses, LoginForm, SignInRequest, signInRequest, RecoveryLinkButton, NotificationBanner, styles$1 as styles, noop, schema, make$2 as make };
/* LoginForm Not a pure module */